import { Translations } from '@/types/types';
import { ApiQueryKey } from '@/configs/ApiQueryKey';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AttributeViewType {
	TILES = 'tiles',
	RADIO = 'radio',
	SELECT = 'select',
	CHECKBOX = 'checkbox',
	INPUT = 'input',
}

export enum ComponentRelationType {
	ATTRIBUTE_VALUE = 'attributeValue',
	PRODUCT_PROPERTY = 'productProperty',
	ATTRIBUTE = 'attribute',
}

export enum ComponentRelationAction {
	SHOW = 'show',
	HIDE = 'hide',
}

export enum RelationConditionOperator {
	LTE = 'lte',
	GTE = 'gte',
	EQ = 'eq',
}

export enum ComponentRelationOperator {
	OR = 'or',
	AND = 'and',
}

export interface ComponentRelationCondition {
	type: ComponentRelationType;
	objectId: string;
}

export interface ComponentRelation {
	action: ComponentRelationAction;
	operator: ComponentRelationOperator;
	conditions: ComponentRelationCondition[];
}

export interface Attribute extends BaseEntity {
	name: string;
	description: string;
	viewType: AttributeViewType;
	listOrder: number;
	suffix?: string;
	status: 'active' | 'inactive';
	image?: {
		path: string;
	};
	translations: Translations<{
		name: string;
		description: string;
	}>;
	attributeValuesIds?: string[];
	relations?: ComponentRelation[];
}

class attributeApi extends EntityApi<Attribute> {
	constructor() {
		super(ApiQueryKey.attributes);
	}
}

export default new attributeApi();
